import React from 'react';
import type { IntelSource } from '../../../types/intel-source.js';
import { Chip } from '../../../components/ui';
import { PlatGlyph } from './PlatGlyph.js';

/**
 * Source column compound cell: glyph + name block + origin chip + mono handle.
 * Matches comp .is-name layout.
 */
interface SourceRowCellProps {
  source: IntelSource;
}

function originChip(source: IntelSource): React.ReactNode {
  if (source.seed === true) {
    return <Chip tone="blue">seed</Chip>;
  }
  if (source.seed === false && source.discoveredAt != null) {
    return <Chip tone="purple">discovered</Chip>;
  }
  // manual — no chip
  return null;
}

export const SourceRowCell: React.FC<SourceRowCellProps> = ({ source }) => {
  const chip = originChip(source);
  return (
    <div className="flex items-center gap-[11px]">
      <PlatGlyph platform={source.platform} />
      <div>
        <div className="flex items-center gap-[7px] font-semibold text-heading text-[13px]">
          <span>{source.name ?? source.handle}</span>
          {chip}
        </div>
        <div className="font-mono text-[11px] text-muted mt-[2px]">{source.handle}</div>
      </div>
    </div>
  );
};
